import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { AuthService } from './auth.service';
import { Utils } from '@/helpers/utils';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const functionCode = route.data['code'];

    // Route không khai báo quyền -> cho qua.
    if (!functionCode) {
      return true;
    }

    // Chưa đăng nhập -> về trang login.
    if (!this.authService.hasToken()) {
      return this.router.parseUrl('/login');
    }

    // Đã đăng nhập nhưng không có quyền với chức năng này -> trang 403.
    const actions = this.authService
      .getFunctionOfUser()
      .find(item => item.code == functionCode)?.actions;
    if (Utils.isEmpty(actions)) {
      return this.router.parseUrl('/forbidden');
    }

    return true;
  }
}
